import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
//import App from './containers/App/App';
import { ThemeProvider } from "./Theme/ThemeContext";
import Main from './Main';
import * as serviceWorker from './serviceWorker';

import 'normalize.css';

ReactDOM.render( <ThemeProvider><Main /></ThemeProvider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
